module.exports = __webpack_public_path__ + "img/iphones.4d1edf6e.png";